import { render, staticRenderFns } from "./Traffic_Record.vue?vue&type=template&id=2f7ab8d6&"
import script from "./Traffic_Record.vue?vue&type=script&lang=js&"
export * from "./Traffic_Record.vue?vue&type=script&lang=js&"
import style0 from "./Traffic_Record.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports